// Function loadSiteHeader loads the SiteHeader class by dynamically importing the js on demand if needed

export function loadSiteHeader($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="SiteHeader"]');

	if(!$wg) {
		// console.info('SiteHeader: no widget found');
		return Promise.reject('SiteHeader widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-site-header-chunk" */ '../widgets/siteHeader').then(wg => {

		const { SiteHeader } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="SiteHeader"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new SiteHeader($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new SiteHeader($wg);
		}


	}).catch(error => error+'An error occurred while loading the SiteHeader widget');

}
